import React from "react";
import logo from "../images/search-analyzer-logo.png";
import logoDark from "../images/search-analyzer-logo-dark.png";

// The dark file is the same mark with a light wordmark. CSS shows one image.
const Logo: React.FC<{ className?: string }> = ({ className = "mt-1 w-32" }) => {
  return (
    <span className="inline-block leading-none">
      <img src={logo} alt="Searchanalyzer Logo" className={`brand-logo-light ${className}`} />
      <img src={logoDark} alt="Searchanalyzer Logo" className={`brand-logo-dark ${className}`} />
    </span>
  );
};

export { Logo };
